import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  CANCEL_BUTTON: `${cleanedFilename(__filename)}-cancel-button`,
  SAVE_BUTTON: `${cleanedFilename(__filename)}-save-button`,
};
